import React, { useEffect } from 'react';
import Alert from '../Alert';

const Notification = ({ item, loading, close, init }) => {
    useEffect(() => {
        init();
    }, [init]);

    return (
        <div className="notification">
            {item ? <Alert {...item} loading={loading} onCloseCallback={close} /> : null}
        </div>
    );
};

export default Notification;
